import { SubMenuItem } from "./subMenuItem";

export class MenuItem {
    isActive: boolean = false;

    public constructor(
        public url: string,
        public name: string,
        public classes: string = null,
        public active: boolean = true,
        public subMenuItems: SubMenuItem[] = [],
        public showSubmenu?: boolean
    ) { }
}
